<template>
    <b-modal
        id="add-user-modal"
        ref="add-user-modal"
        size="md"
        :title="$t('group.internship.edit_group_manager')"
        modal-class="apprentice-default-modal group-modal-admin"
        :ok-title="$t('common.close')"
        ok-only
        @show="load">
        <design-2021-apprentice-data-table
            v-if="Object(groupAdminItems).length >= 1 && !loading"
            :items="groupAdminItems"
            :fields="groupAdminFields">
            <template v-slot:cell(action)="data">
                <b-button
                    class="btn-chain-link"
                    variant="primary-icon-only"
                    @click="onSelect(data.item)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>

        <div
            class="not-found with-header empty-list"
            v-if="Object(groupAdminItems).length == 0 && !loading">
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">
                {{ $t('group.internship.all_teachers_are_already_linked_or_no_teachers_were_found') }}
            </div>
        </div>

        <div
            class="loading"
            v-show="loading">
            <i class="fas fa-spinner fa-spin"></i>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-show-add-user-modal-component',
    props: ['groupId'],
    data() {
        return {
            loading: false,
            groupAdminFields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
            groupAdminItems: null,
        };
    },

    methods: {
        onSelect(user) {
            this.$emit('user-added', user);
        },
        load() {
            this.loading = true;
            this.axios
                .get(this.routes.groupGetUsers(this.groupId) + '?query=&limit=10000&ascending=1&page=1&byColumn=0')
                .then(
                    (response) => {
                        this.groupAdminItems = response.data.data;
                        this.loading = false;
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
        },
        reload() {
            this.load();
        },
    },
    created() {
        this.load();
    },
};
</script>

<style scoped lang="scss">
.loading {
    display: flex;
    justify-content: center;
    color: var(--primary);
    font-size: 1.375rem;
}
</style>
